export const removeAllConfirmationMessage =
  '本当にすべて削除してもよろしいですか？\n（この操作は"Undo"ボタンで取り消すことができます）';
